webpackJsonp([114276838955818,60335399758886],{

/***/ 166:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Whistle Messaging, Inc","description":"Top Rated Guest Messaging Software by HotelTechReport, Whistle brings contactless text messaging to your hotel and hotel guests, and integrates your property management system instantly."}},"landing":{"edges":[{"node":{"id":"/home/circleci/project/src/pages/landing/aws.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"aws","label":"AWS"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/clock.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"clock","label":"Clock PMS"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/quore.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"quore","label":"Quore"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/mews.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"mews","label":"Mews"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/sensorindustries.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"sensorindustries","label":"Sensor Industries"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/roomkeypms.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"roomkeypms","label":"RoomKeyPMS"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/skytouch.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"skytouch","label":"SkyTouch"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/stayntouch.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"stayntouch","label":"StayNTouch"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/thinkreservations.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"thinkreservations","label":"ThinkReservations"}}},{"node":{"id":"/home/circleci/project/src/pages/landing/webrezpro.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"webrezpro","label":"WebRezPro"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(298);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(166);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGhlaWdodD0iNDguMyIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQgbWVldCIgdmVyc2lvbj0iMS4wIiB2aWV3Qm94PSIxOC4wIDYuMSAyMi40IDQ4LjMiIHdpZHRoPSIyMi40IiB6b29tQW5kUGFuPSJtYWduaWZ5Ij48ZyBpZD0iY2hhbmdlMV8xIj48cGF0aCBkPSJNNDAuNDMsMjEuNzM5aC03LjY0NnYtNS4wMTRjMC0xLjg4NCwxLjI0OC0yLjMyMiwyLjEyNy0yLjMyMmMwLjg3NywwLDUuMzk2LDAsNS4zOTYsMFY2LjEyNWwtNy40MzEtMC4wMjggYy04LjI0OCwwLTEwLjEyNSw2LjE3NC0xMC4xMjUsMTAuMTI1djUuNTE4aC00Ljc3djguNTNoNC43N2MwLDEwLjk0NiwwLDI0LjEzNywwLDI0LjEzN2gxMC4wMzNjMCwwLDAtMTMuMzIsMC0yNC4xMzdoNi43NzEgTDQwLjQzLDIxLjczOXoiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+"

/***/ }),

/***/ 956:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 959:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGhlaWdodD0iNDkuNyIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQgbWVldCIgdmVyc2lvbj0iMS4wIiB2aWV3Qm94PSIzLjUgNC43IDQ5LjQgNDkuNyIgd2lkdGg9IjQ5LjQiIHpvb21BbmRQYW49Im1hZ25pZnkiPjxnIGlkPSJjaGFuZ2UxXzEiPjxwYXRoIGQ9Ik0zMC4wNzEsMjcuMTAxdi0wLjA3N2MtMC4wMTYsMC4wMjUtMC4wMzMsMC4wNTItMC4wNSwwLjA3N0gzMC4wNzF6IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTQ5LjI2NSw0LjY2N0g3LjE0NWMtMi4wMTcsMC0zLjY1MSwxLjU5Ny0zLjY1MSwzLjU2M3Y0Mi42MTJjMCwxLjk2NywxLjYzNSwzLjU2MiwzLjY1MSwzLjU2Mmg0Mi4xMiBjMi4wMTksMCwzLjY1My0xLjU5NywzLjY1My0zLjU2MlY4LjIzQzUyLjkxOSw2LjI2Miw1MS4yODMsNC42NjcsNDkuMjY1LDQuNjY3eiBNMTguNDc1LDQ2LjMwNEgxMS4wMVYyMy44NDVoNy40NjZWNDYuMzA0eiBNMTQuNzQzLDIwLjc3N2gtMC4wNWMtMi41MDQsMC00LjEyNC0xLjcyNi00LjEyNC0zLjg4YzAtMi4yMDMsMS42Ny0zLjg4LDQuMjIzLTMuODhjMi41NTUsMCw0LjEyNSwxLjY3Nyw0LjE3NSwzLjg4IEMxOC45NjcsMTkuMDUyLDE3LjM0NSwyMC43NzcsMTQuNzQzLDIwLjc3N3ogTTQ1LjM5NCw0Ni4zMDRoLTcuNDY1VjM0LjI4NmMwLTMuMDE4LTEuMDgtNS4wNzgtMy43ODEtNS4wNzggYy0yLjA2MiwwLTMuMjksMS4zOS0zLjgzMSwyLjczMWMtMC4xOTcsMC40NzktMC4yNDUsMS4xNDgtMC4yNDUsMS44MnYxMi41NDRoLTcuNDY1YzAsMCwwLjA5OC0yMC4zNTQsMC0yMi40Nmg3LjQ2NXYzLjE4IGMwLjk5Mi0xLjUzLDIuNzY2LTMuNzA5LDYuNzI5LTMuNzA5YzQuOTExLDAsOC41OTUsMy4yMTEsOC41OTUsMTAuMTA5TDQ1LjM5NCw0Ni4zMDRMNDUuMzk0LDQ2LjMwNHoiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+"

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/social-hero.90e303f1.png";

/***/ }),

/***/ 989:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGhlaWdodD0iNDAuMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQgbWVldCIgdmVyc2lvbj0iMS4wIiB2aWV3Qm94PSIzLjYgMTAuMyA0OS4zIDQwLjAiIHdpZHRoPSI0OS4zIiB6b29tQW5kUGFuPSJtYWduaWZ5Ij48ZyBpZD0iY2hhbmdlMV8xIj48cGF0aCBkPSJNNTIuODM3LDE1LjA2NWMtMS44MTEsMC44MDUtMy43NiwxLjM0OC01LjgwNSwxLjU5MWMyLjA4OC0xLjI1LDMuNjg5LTMuMjMsNC40NDQtNS41OTJjLTEuOTUzLDEuMTU5LTQuMTE1LDItNi40MTgsMi40NTQgYy0xLjg0NC0xLjk2NC00LjQ3MS0zLjE5Mi03LjM3Ny0zLjE5MmMtNS41ODEsMC0xMC4xMDYsNC41MjUtMTAuMTA2LDEwLjEwN2MwLDAuNzkxLDAuMDg5LDEuNTYyLDAuMjYyLDIuMzAzIGMtOC4zOTktMC40MjItMTUuODQ4LTQuNDQ1LTIwLjgzMy0xMC41NjFjLTAuODcsMS40OTItMS4zNjcsMy4yMjktMS4zNjcsNS4wODJjMCwzLjUwNywxLjc4Myw2LjYwMSw0LjQ5NSw4LjQxMiBjLTEuNjU1LTAuMDUzLTMuMjE1LTAuNTA4LTQuNTc3LTEuMjY1Yy0wLjAwMSwwLjA0Mi0wLjAwMSwwLjA4NS0wLjAwMSwwLjEyOGMwLDQuODk2LDMuNDgzLDguOTgsOC4xMDcsOS45MSBjLTAuODQ4LDAuMjI5LTEuNzQxLDAuMzU0LTIuNjYzLDAuMzU0Yy0wLjY1MSwwLTEuMjg1LTAuMDYyLTEuOTAxLTAuMTgyYzEuMjg2LDQuMDE1LDUuMDE5LDYuOTM4LDkuNDQsNy4wMTkgYy0zLjQ1OSwyLjcxMi03LjgxNSw0LjMyNy0xMi41NTIsNC4zMjdjLTAuODE1LDAtMS42Mi0wLjA0OC0yLjQxMS0wLjE0MmM0LjQ3NCwyLjg2OSw5Ljc4Niw0LjU0MSwxNS40OTMsNC41NDEgYzE4LjU5MSwwLDI4Ljc1Ni0xNS40LDI4Ljc1Ni0yOC43NTZjMC0wLjQzOC0wLjAwOS0wLjg3NS0wLjAyOC0xLjMxQzQ5Ljc2OSwxOC44NzMsNTEuNDgzLDE3LjA5Miw1Mi44MzcsMTUuMDY1eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emotion = __webpack_require__(6);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Section = __webpack_require__(13);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _facebookIcon = __webpack_require__(937);
	
	var _facebookIcon2 = _interopRequireDefault(_facebookIcon);
	
	var _instagramIcon = __webpack_require__(956);
	
	var _instagramIcon2 = _interopRequireDefault(_instagramIcon);
	
	var _linkedinIcon = __webpack_require__(959);
	
	var _linkedinIcon2 = _interopRequireDefault(_linkedinIcon);
	
	var _twitterIcon = __webpack_require__(989);
	
	var _twitterIcon2 = _interopRequireDefault(_twitterIcon);
	
	var _HubspotForm = __webpack_require__(204);
	
	var _HubspotForm2 = _interopRequireDefault(_HubspotForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterClass = /*#__PURE__*/(0, _emotion.css)('clear:both;background-color:#00b386;display:flex;flex-direction:column-reverse;padding-bottom:10rem;padding-top:3rem;@media (min-width:767px){flex-direction:row;}');
	
	var NavContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1r41jcc0'
	})('display:flex;flex-direction:column;flex:2;');
	
	var Nav = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1r41jcc1'
	})('flex:1;display:flex;flex-direction:row;position:relative;z-index:1;padding-top:1rem;@media (min-width:767px){border-top:none;padding-top:0;}');
	
	var NavList = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'e1r41jcc2'
	})('list-style:none;padding:0.5rem;font-size:1.2rem;line-height:1.5rem;&:last-child{border:none;}@media (min-width:767px){padding:1rem 2rem;}');
	
	var NavListItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'e1r41jcc3'
	})(function (props) {
	  return '\n  color: white;\n  margin-bottom: 1rem;\n  font-weight: ' + (props.bold ? 'bold' : '300') + ';\n\n  a {\n    color: white\n  }\n';
	});
	
	var Icon = /*#__PURE__*/(0, _reactEmotion2.default)('img', {
	  target: 'e1r41jcc4'
	})('max-width:3rem;max-height:3rem;margin-right:1rem;color:white;');
	
	var Container = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1r41jcc5'
	})('display:flex;flex-direction:column-reverse;z-index:10;@media (min-width:767px){flex-direction:row;}');
	
	var EmailSubscribeContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1r41jcc6'
	})('flex:2;padding:3rem;text-align:center;color:white;background-color:rgb(252 199 27 / 1);');
	
	var EmailCTAHeader = /*#__PURE__*/(0, _reactEmotion2.default)('h3', {
	  target: 'e1r41jcc7'
	})('font-size:3rem;');
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(
	        _Section2.default,
	        { className: FooterClass, shading: true },
	        _react2.default.createElement(
	          Container,
	          null,
	          _react2.default.createElement(
	            NavContainer,
	            null,
	            _react2.default.createElement(
	              Nav,
	              null,
	              _react2.default.createElement(
	                NavList,
	                null,
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/#partners' },
	                    'Partners'
	                  )
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/#how-it-works' },
	                    'How It Works'
	                  )
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/#features' },
	                    'Features'
	                  )
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/testimonials' },
	                    'Testimonials'
	                  )
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://app.trywhistle.com/login' },
	                    'Login'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                NavList,
	                null,
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/news' },
	                    'News'
	                  )
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/tos' },
	                    'Terms of Use'
	                  )
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/privacy' },
	                    'Privacy Policy'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Nav,
	              null,
	              _react2.default.createElement(
	                NavList,
	                null,
	                _react2.default.createElement(
	                  NavListItem,
	                  { bold: true },
	                  'Contact Us'
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  'sales@trywhistle.com'
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  'Whistle Messaging, Inc. ',
	                  _react2.default.createElement('br', null),
	                  'Los Angeles, CA 91361'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Nav,
	              null,
	              _react2.default.createElement(
	                NavList,
	                null,
	                _react2.default.createElement(
	                  NavListItem,
	                  { bold: true },
	                  'Follow Us'
	                ),
	                _react2.default.createElement(
	                  NavListItem,
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.linkedin.com/company/whistle-inc-/', rel: 'noopener noreferrer', target: '_blank' },
	                    _react2.default.createElement(Icon, { src: _linkedinIcon2.default })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.instagram.com/whistlemessaging/', rel: 'noopener noreferrer', target: '_blank' },
	                    _react2.default.createElement(Icon, { src: _instagramIcon2.default })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.facebook.com/trywhistle', rel: 'noopener noreferrer', target: '_blank' },
	                    _react2.default.createElement(Icon, { src: _facebookIcon2.default })
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://twitter.com/trywhistle', rel: 'noopener noreferrer', target: '_blank' },
	                    _react2.default.createElement(Icon, { src: _twitterIcon2.default })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            EmailSubscribeContainer,
	            null,
	            _react2.default.createElement(
	              EmailCTAHeader,
	              null,
	              'Hi there!'
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'GET UPDATES, OFFERS, INSIDER INFORMATION AND MORE. '
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Sign up below to get Whistling.'
	            ),
	            _react2.default.createElement(_HubspotForm2.default, {
	              id: 'email-subscribers',
	              formId: '062b7602-8729-4618-bc12-2ceeb2842e10'
	            }),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We will protect your personal information. See our ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/privacy' },
	                'Privacy Policy'
	              ),
	              ' for more details. '
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(6);
	
	var _lodash = __webpack_require__(24);
	
	var _logo = __webpack_require__(292);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Navigation = __webpack_require__(291);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _MobileNav = __webpack_require__(289);
	
	var _MobileNav2 = _interopRequireDefault(_MobileNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderClass = /*#__PURE__*/(0, _emotion.css)('height:5rem;position:fixed;top:0;left:0;right:0;box-shadow:0 1px 4px rgba(53,57,71,.3);background-color:#fff;display:flex;padding:0 2rem;z-index:100;@media (min-width:776px){padding:0 3.1rem;}');
	var LogoContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
		target: 'elye7m40'
	})('flex:1;display:flex;align-items:center;');
	var LogoWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
		target: 'elye7m41'
	})('width:6rem;padding:1rem 0;display:inline-block;position:relative;z-index:100;');
	
	// @media (min-width: 1025px) {
	// 	width: 13rem;
	// 	padding: 1rem 2.5rem;
	// }
	
	var NavigationWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('nav', {
		target: 'elye7m42'
	})('display:none;@media (min-width:1025px){display:flex;}');
	
	var MobileNavWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
		target: 'elye7m43'
	})('display:flex;align-items:center;@media (min-width:1025px){display:none;}');
	
	var Text = /*#__PURE__*/(0, _reactEmotion2.default)('h3', {
		target: 'elye7m44'
	})('font-weight:200;margin-bottom:0;margin-left:1rem;font-style:italic;margin-top:1rem;@media (min-width:800px){margin-top:0;}@media (min-width:1200px){margin-top:1rem;}');
	
	var buildLinks = function buildLinks(data) {
		var links = [{ label: 'Integrations', to: '/integrations' }, { to: '/how-it-works', label: 'How It Works' }, { to: '/features', label: 'Features' }, {
			label: 'Testimonials',
			to: '/testimonials',
			links: [{ to: '/clients', label: 'Clients' }]
		}, {
			label: 'About',
			to: '/about',
			links: [{ to: '/about', label: 'About Us' }, { to: '/news', label: 'News' }]
		}, {
			label: 'Get Started',
			to: '/schedule',
			button: true,
			links: [{ to: '/schedule', label: 'Schedule a Demo' }, { to: 'https://app.trywhistle.com/register?source=whistle-marketing', label: 'Try it Free', external: true }]
		}, {
			label: 'Login',
			external: true,
			to: 'https://app.trywhistle.com/login'
		}];
		// console.log("DATA", data)
		// data.edges.map(d => {
		// 	const { label, title } = get(d, ['node', 'frontmatter']) || {}
		// 	const partner = {
		// 		to: `/${title}`,
		// 		label,
		// 	}
		// 	links[1].links.push(partner)
		// }) 
		return links;
	};
	
	var Header = function Header(props) {
		var links = buildLinks(props);
	
		return _react2.default.createElement(
			'header',
			{ className: HeaderClass },
			_react2.default.createElement(
				LogoContainer,
				null,
				_react2.default.createElement(
					LogoWrapper,
					null,
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/', title: '#1 Hotel Messaging Platform' },
						_react2.default.createElement(_logo2.default, null)
					)
				)
			),
			_react2.default.createElement(
				NavigationWrapper,
				null,
				_react2.default.createElement(_Navigation2.default, { links: links })
			),
			_react2.default.createElement(
				MobileNavWrapper,
				null,
				_react2.default.createElement(_MobileNav2.default, { links: links })
			)
		);
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(6);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'e13h5kfs0'
	})('list-style:none;text-align:left;margin-top:-1px;padding:0rem 1rem;border-bottom:1px solid #F8F8F8;background:#fff;&:last-child,&:first-child{border:none;padding:0.4rem 1rem;}a{display:block;}@media (min-width:800px){text-align:center;}');
	
	var DropdownNavClass = /*#__PURE__*/(0, _emotion.css)('width:100%;@media (min-width:800px){pointer-events:none;transition:.2s ease-out;opacity:0;box-shadow:0 1px 4px rgba(53,57,71,.3);position:absolute;display:flex;flex-direction:column;align-items:flex-start;min-width:300px;right:-50px;top:3.3rem;}');
	
	var Chevron = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e13h5kfs1'
	})('&.flipped{-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-o-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg);}');
	
	var IconClass = /*#__PURE__*/(0, _emotion.css)('color:black;');
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e13h5kfs2'
	})('position:relative;display:flex;justify-content:space-between;align-items:flex-start;flex-direction:column;width:100%;&:hover,&:focus{.', DropdownNavClass, '{pointer-events:all;opacity:1;}}');
	
	var SubContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e13h5kfs3'
	})();
	
	var MobileDropdown = function (_React$Component) {
	  _inherits(MobileDropdown, _React$Component);
	
	  function MobileDropdown(props) {
	    _classCallCheck(this, MobileDropdown);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      toggled: false
	    };
	    return _this;
	  }
	
	  MobileDropdown.prototype.toggle = function toggle() {
	    if (this.props.nav.links) {
	      this.setState({ toggled: !this.state.toggled });
	    }
	  };
	
	  MobileDropdown.prototype.renderLinks = function renderLinks(links) {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      SubContainer,
	      null,
	      links.map(function (link, idx) {
	        return _react2.default.createElement(
	          NavItem,
	          { key: link.to },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              anchor: true,
	              navLink: true,
	              to: link.to,
	              title: link.label,
	              external: link.external,
	              icon: 'arrow_right_alt',
	              onClick: function onClick() {
	                return _this2.props.onNavigate && _this2.props.onNavigate();
	              }
	            },
	            link.label
	          )
	        );
	      })
	    );
	  };
	
	  MobileDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props$nav = this.props.nav,
	        label = _props$nav.label,
	        to = _props$nav.to,
	        links = _props$nav.links;
	
	    return _react2.default.createElement(
	      Wrapper,
	      { onClick: function onClick() {
	          return _this3.toggle();
	        } },
	      _react2.default.createElement(
	        _Button2.default,
	        { anchor: true, navLink: true, to: to, icon: links.length, mobile: true },
	        label,
	        links ? _react2.default.createElement(
	          Chevron,
	          { className: this.state.toggled ? 'flipped' : '' },
	          _react2.default.createElement(
	            'i',
	            { className: IconClass + ' material-icons' },
	            'expand_more'
	          )
	        ) : null
	      ),
	      _react2.default.createElement(
	        'nav',
	        { className: DropdownNavClass },
	        this.state.toggled ? this.renderLinks(links) : null
	      )
	    );
	  };
	
	  return MobileDropdown;
	}(_react2.default.Component);
	
	exports.default = MobileDropdown;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(6);
	
	__webpack_require__(414);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MobileDropdown = __webpack_require__(288);
	
	var _MobileDropdown2 = _interopRequireDefault(_MobileDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileNavClass = /*#__PURE__*/(0, _emotion.css)('color:#232323;');
	
	var NavClass = /*#__PURE__*/(0, _emotion.css)('transition:.25s ease-out;position:absolute;left:0;top:5rem;right:0;box-shadow:0 2px 4px rgba(0,0,0,0.15);height:0;z-index:0;transform:translateY(-1300px);&.is-active{height:calc(100vh - 80px);overflow-y:scroll;transform:translateY(0);}');
	
	var ButtonContainer = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e181jo400'
	})('display:flex;justify-content:center;');
	
	var MobileNavClassMenu = /*#__PURE__*/(0, _emotion.css)('position:relative;z-index:100;');
	
	var NavItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'e181jo401'
	})('text-align:left;padding:0.4rem 1rem;border-bottom:1px solid #F8F8F8;background:#fff;&:last-child{border:none;padding:2rem;}@media (min-width:800px){padding:1rem;text-align:center;}');
	
	// {props.links.map(link => (
	//   <li key={link.to}>
	//     <Button anchor navLink to={link.to}>{link.label}</Button>
	//   </li>
	// ))}
	
	var MobileNav = function (_React$Component) {
	  _inherits(MobileNav, _React$Component);
	
	  function MobileNav(props) {
	    _classCallCheck(this, MobileNav);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isOpen: false,
	      toggled: {}
	    };
	
	    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	    return _this;
	  }
	
	  MobileNav.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('mousedown', this.handleClickOutside);
	  };
	
	  MobileNav.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('mousedown', this.handleClickOutside);
	  };
	
	  MobileNav.prototype.handleClickOutside = function handleClickOutside(event) {
	    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && !this.menuRef.contains(event.target)) {
	      this.setState({ isOpen: false });
	    }
	  };
	
	  MobileNav.prototype.toggleNav = function toggleNav() {
	    this.setState({ isOpen: !this.state.isOpen });
	  };
	
	  MobileNav.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: MobileNavClass },
	      _react2.default.createElement(
	        'button',
	        { title: 'Menu', ref: function ref(_ref) {
	            _this2.menuRef = _ref;
	          }, onClick: function onClick() {
	            return _this2.toggleNav();
	          }, className: MobileNavClassMenu + ' hamburger hamburger--spin ' + (this.state.isOpen ? 'is-active' : ''), type: 'button' },
	        _react2.default.createElement(
	          'span',
	          { className: 'hamburger-box' },
	          _react2.default.createElement('span', { className: 'hamburger-inner' })
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { ref: function ref(_ref2) {
	            _this2.wrapperRef = _ref2;
	          }, className: NavClass + ' ' + (this.state.isOpen ? 'is-active' : '') },
	        this.props.links.map(function (link, idx) {
	          if (link.links) {
	            return _react2.default.createElement(
	              NavItem,
	              { key: idx },
	              _react2.default.createElement(_MobileDropdown2.default, {
	                key: link.label,
	                nav: link,
	                onNavigate: function onNavigate() {
	                  return _this2.toggleNav();
	                }
	              })
	            );
	          } else if (link.button) {
	            return null;
	          } else {
	            return _react2.default.createElement(
	              NavItem,
	              { key: idx },
	              _react2.default.createElement(
	                _Button2.default,
	                { mobile: true, anchor: true, navLink: true, to: link.to, title: link.label, onClick: function onClick() {
	                    return _this2.toggleNav();
	                  } },
	                link.label
	              )
	            );
	          }
	        }),
	        _react2.default.createElement(
	          NavItem,
	          null,
	          _react2.default.createElement(
	            ButtonContainer,
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { to: 'https://app.trywhistle.com/login', flat: true, horizontalPadding: true, external: true },
	              'Login'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return MobileNav;
	}(_react2.default.Component);
	
	exports.default = MobileNav;
	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotion = __webpack_require__(6);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavItem = /*#__PURE__*/(0, _reactEmotion2.default)('li', {
	  target: 'ejh78qy0'
	})('list-style:none;text-align:left;border-bottom:1px solid #F8F8F8;background:#fff;&:last-child,&:first-child{border:none;}a{display:block;margin:0;border-radius:0;}@media (min-width:800px){text-align:center;}');
	
	var DropdownNavClass = /*#__PURE__*/(0, _emotion.css)('@media (min-width:800px){pointer-events:none;transition:.2s ease-out;opacity:0;box-shadow:0 1px 4px rgba(53,57,71,.3);position:absolute;display:flex;flex-direction:column;min-width:300px;right:-50px;top:3.3rem;}');
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ejh78qy1'
	})('position:relative;&:hover,&:focus{.', DropdownNavClass, '{pointer-events:all;opacity:1;}}');
	
	var NavDropdown = function (_React$Component) {
	  _inherits(NavDropdown, _React$Component);
	
	  function NavDropdown(props) {
	    _classCallCheck(this, NavDropdown);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  NavDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$nav = this.props.nav,
	        label = _props$nav.label,
	        links = _props$nav.links,
	        to = _props$nav.to,
	        button = _props$nav.button;
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        _Button2.default,
	        { anchor: true, navLink: true, to: to, title: label, button: button },
	        label
	      ),
	      _react2.default.createElement(
	        'nav',
	        { className: DropdownNavClass },
	        links.map(function (link, idx) {
	          return _react2.default.createElement(
	            NavItem,
	            { key: idx },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                anchor: true,
	                navLink: true,
	                external: link.external,
	                to: link.to,
	                title: link.label,
	                icon: 'arrow_right_alt',
	                onClick: function onClick() {
	                  return _this2.props.onNavigate && _this2.props.onNavigate();
	                }
	              },
	              link.label
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2.default.Component);
	
	exports.default = NavDropdown;
	module.exports = exports['default'];

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _NavDropdown = __webpack_require__(290);
	
	var _NavDropdown2 = _interopRequireDefault(_NavDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = /*#__PURE__*/(0, _reactEmotion2.default)('ul', {
	  target: 'ezjfsau0'
	})('display:flex;align-items:center;li{display:inline;}');
	
	var Navigation = function Navigation(props) {
	  return _react2.default.createElement(
	    Nav,
	    null,
	    props.links.map(function (link, idx) {
	      if (link.links) {
	        return _react2.default.createElement(
	          'li',
	          { key: idx },
	          _react2.default.createElement(_NavDropdown2.default, { key: link.label, nav: link })
	        );
	      } else {
	        return _react2.default.createElement(
	          'li',
	          { key: idx },
	          _react2.default.createElement(
	            _Button2.default,
	            _extends({ anchor: true, navLink: true, title: link.label }, link),
	            link.label
	          )
	        );
	      }
	    })
	  );
	};
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	    return _react2.default.createElement(
	        "svg",
	        { height: "3rem", viewBox: "0 0 553 272", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { d: "M134.603,0.241 C136.533,0.241 137.498,1.206 136.533,3.136 L103.874,113.171 C103.231,115.103 101.623,116.069 99.372,116.069 L89.075,116.069 C86.822,116.069 85.052,115.265 84.571,113.171 L68.162,34.989 L50.788,113.171 C50.305,115.265 48.535,116.069 46.282,116.069 L35.986,116.069 C33.735,116.069 32.126,115.265 31.482,113.171 L0.434,3.136 C-0.531,1.206 0.113,0.241 2.365,0.241 L17.648,0.241 C19.901,0.241 21.507,1.044 21.99,3.295 L37.435,67.808 L41.94,95.96 L46.443,67.808 L61.888,3.295 C62.369,1.206 63.817,0.241 65.911,0.241 L75.884,0.241 C77.975,0.241 79.422,1.206 79.904,3.295 L94.222,67.808 L98.245,95.96 L103.231,67.808 L119.802,3.295 C120.606,1.206 121.893,0.241 124.147,0.241 L134.603,0.241 Z", id: "path-1" }),
	            _react2.default.createElement("path", { d: "M41.849,33.485 C58.903,33.485 73.222,44.103 73.222,77.563 L73.222,115.852 C73.222,118.103 72.256,119.069 70.003,119.069 L57.134,119.069 C54.88,119.069 53.916,118.103 53.916,115.852 L53.916,77.563 C53.916,52.468 48.285,46.997 39.116,46.997 C26.888,46.997 19.973,54.238 19.973,72.74 L19.973,115.852 C19.973,118.103 19.006,119.069 16.755,119.069 L3.886,119.069 C1.632,119.069 0.667,118.103 0.667,115.852 L0.667,3.241 C0.667,0.99 1.632,0.022 3.886,0.022 L16.755,0.022 C19.006,0.022 19.973,0.99 19.973,3.241 L19.973,45.226 L20.292,45.226 C23.671,39.115 29.946,33.485 41.849,33.485 Z", id: "path-3" }),
	            _react2.default.createElement("path", { d: "M45.136,37.646 C59.131,41.668 63.476,49.389 63.476,61.937 C63.476,79.311 47.709,88 30.016,88 C16.499,88 4.114,84.3 1.057,80.118 C-0.068,78.507 -0.068,77.385 0.895,75.935 L4.273,70.784 C5.077,69.661 7.009,69.98 8.459,70.464 C14.73,72.556 21.166,74.488 29.047,74.488 C42.4,74.488 45.136,68.857 45.136,63.709 C45.136,58.72 41.919,56.629 32.586,53.734 L18.756,49.552 C6.687,45.851 1.701,36.842 1.701,26.226 C1.701,11.425 12.154,0.325 31.785,0.325 C45.458,0.325 56.236,4.667 59.775,8.206 C60.418,8.852 61.382,9.975 59.775,12.388 L56.396,17.537 C55.754,18.984 53.663,18.34 52.213,17.859 C46.421,15.767 40.469,13.838 33.554,13.838 C24.061,13.838 20.038,18.021 20.038,24.294 C20.038,27.996 21.808,30.89 26.314,32.178 L45.136,37.646 Z", id: "path-5" }),
	            _react2.default.createElement("path", { d: "M41.506,21.414 C43.76,21.414 44.723,22.379 44.723,24.632 L44.723,30.907 C44.723,33.158 43.76,34.123 41.506,34.123 L31.372,34.123 L31.372,80.456 C31.372,88.339 35.395,91.556 39.09,91.556 L40.221,91.556 C42.472,91.556 43.435,92.522 43.435,94.773 L43.435,101.852 C43.435,104.103 42.472,105.069 40.221,105.069 L34.27,105.069 C19.79,105.069 12.066,96.867 12.066,79.974 L12.066,34.123 L3.701,34.123 C1.447,34.123 0.484,33.158 0.484,30.907 L0.484,24.632 C0.484,22.379 1.447,21.414 3.701,21.414 L12.066,21.414 L12.066,9.028 C12.066,6.775 13.194,6.615 15.283,5.809 L28.155,0.985 C30.243,0.179 31.372,1.951 31.372,4.202 L31.372,21.414 L41.506,21.414 Z", id: "path-7" }),
	            _react2.default.createElement("path", { d: "M25.53,105.556 C27.781,105.556 28.747,106.522 28.747,108.773 L28.747,115.852 C28.747,118.103 27.781,119.069 25.53,119.069 L22.795,119.069 C8.316,119.069 0.595,110.867 0.595,93.974 L0.595,3.241 C0.595,0.99 1.558,0.022 3.812,0.022 L16.681,0.022 C18.932,0.022 19.897,0.99 19.897,3.241 L19.897,92.846 C19.897,101.857 22.313,105.556 24.402,105.556 L25.53,105.556 Z", id: "path-9" }),
	            _react2.default.createElement("path", { d: "M36.86,13.838 C25.116,13.838 20.934,24.776 19.968,37.486 L44.743,37.486 C49.732,37.486 51.018,36.842 51.018,32.015 C51.018,22.525 45.388,13.838 36.86,13.838 Z M63.405,70.784 L66.781,75.935 C67.747,77.385 67.909,78.669 66.622,80.118 C63.564,83.656 51.821,88 38.147,88 C8.386,88 0.343,67.567 0.343,45.044 C0.343,20.272 9.993,0.325 36.057,0.325 C55.522,0.325 70.482,11.584 70.482,34.911 C70.482,47.301 66.3,50.999 52.949,50.999 L19.968,50.999 C21.255,64.513 26.082,74.488 40.239,74.488 C46.513,74.488 52.627,72.556 59.223,70.464 C62.439,69.498 62.924,70.142 63.405,70.784 Z", id: "path-11" }),
	            _react2.default.createElement("path", { d: "M16.396,0.118 C18.647,0.118 19.612,1.081 19.612,3.334 L19.612,100.852 C19.612,103.103 18.647,104.069 16.396,104.069 L3.526,104.069 C1.272,104.069 0.308,103.103 0.308,100.852 L0.308,24.515 L14.372,24.439 L0.308,13.384 L0.308,3.334 C0.308,1.081 1.272,0.118 3.526,0.118 L16.396,0.118 Z", id: "path-13" }),
	            _react2.default.createElement("path", { d: "M134.772,0.792 C150.465,0.792 163.191,13.515 163.191,29.21 L163.191,94.965 C163.191,110.66 150.465,123.382 134.772,123.382 L86.338,123.382 L122.364,179.474 L50.012,123.382 L28.522,123.382 C12.826,123.382 0.105,110.66 0.105,94.965 L0.105,29.21 C0.105,13.515 12.826,0.792 28.522,0.792 L134.772,0.792 Z", id: "path-15" }),
	            _react2.default.createElement("path", { d: "M16.766,3.863 L10.83,3.863 L10.83,21 L5.936,21 L5.936,3.863 L0,3.863 L0,0 L16.766,0 L16.766,3.863 Z M42.958,0 L42.958,21 L38.644,21 L38.644,8.922 C38.644,8.643 38.651,8.34 38.666,8.014 C38.68,7.687 38.707,7.356 38.745,7.019 L33.142,17.815 C32.968,18.151 32.734,18.406 32.44,18.579 C32.145,18.752 31.81,18.838 31.433,18.838 L30.767,18.838 C30.391,18.838 30.055,18.752 29.761,18.579 C29.467,18.406 29.233,18.151 29.059,17.815 L23.456,6.99 C23.484,7.336 23.509,7.675 23.528,8.007 C23.547,8.338 23.557,8.643 23.557,8.922 L23.557,21 L19.242,21 L19.242,0 L22.978,0 C23.19,0 23.376,0.005 23.535,0.014 C23.695,0.024 23.837,0.053 23.962,0.101 C24.088,0.149 24.201,0.223 24.303,0.324 C24.404,0.425 24.503,0.567 24.599,0.749 L30.029,11.401 C30.222,11.766 30.408,12.146 30.586,12.539 C30.765,12.933 30.936,13.337 31.1,13.75 C31.265,13.327 31.436,12.914 31.614,12.511 C31.793,12.107 31.984,11.723 32.186,11.358 L37.601,0.749 C37.698,0.567 37.797,0.425 37.898,0.324 C38,0.223 38.113,0.149 38.238,0.101 C38.364,0.053 38.506,0.024 38.666,0.014 C38.825,0.005 39.011,0 39.223,0 L42.958,0 Z", id: "path-17" })
	        ),
	        _react2.default.createElement(
	            "g",
	            { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	            _react2.default.createElement(
	                "g",
	                { id: "WhistleLogoTM-2.59.19-PM" },
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-3", transform: "translate(0.000000, 154.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-2", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-1" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-2" }),
	                    _react2.default.createElement("polygon", { id: "Fill-1", fill: "#1AA97B", mask: "url(#mask-2)", points: "-0.1 116.08 136.94 116.08 136.94 0.16 -0.1 0.16" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-6", transform: "translate(146.000000, 151.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-4", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-3" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-5" }),
	                    _react2.default.createElement("polygon", { id: "Fill-4", fill: "#1AA97B", mask: "url(#mask-4)", points: "0.66 119.08 73.26 119.08 73.26 -0.08 0.66 -0.08" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-9", transform: "translate(269.000000, 184.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-6", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-5" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-8" }),
	                    _react2.default.createElement("polygon", { id: "Fill-7", fill: "#1AA97B", mask: "url(#mask-6)", points: "0.18 88 63.54 88 63.54 0.28 0.18 0.28" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-12", transform: "translate(341.000000, 165.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-8", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-7" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-11" }),
	                    _react2.default.createElement("polygon", { id: "Fill-10", fill: "#1AA97B", mask: "url(#mask-8)", points: "0.42 105.08 44.82 105.08 44.82 0.68 0.42 0.68" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-15", transform: "translate(398.000000, 151.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-10", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-9" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-14" }),
	                    _react2.default.createElement("polygon", { id: "Fill-13", fill: "#1AA97B", mask: "url(#mask-10)", points: "0.54 119.08 28.86 119.08 28.86 -0.08 0.54 -0.08" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-18", transform: "translate(433.000000, 184.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-12", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-11" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-17" }),
	                    _react2.default.createElement("polygon", { id: "Fill-16", fill: "#1AA97B", mask: "url(#mask-12)", points: "0.34 88 70.54 88 70.54 0.28 0.34 0.28" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-21", transform: "translate(235.000000, 166.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-14", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-13" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-20" }),
	                    _react2.default.createElement("polygon", { id: "Fill-19", fill: "#1AA97B", mask: "url(#mask-14)", points: "0.22 104.08 19.66 104.08 19.66 0.04 0.22 0.04" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-24", transform: "translate(106.000000, 0.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-16", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-15" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-23" }),
	                    _react2.default.createElement("polygon", { id: "Fill-22", fill: "#FCC71B", mask: "url(#mask-16)", points: "0.1 179.48 163.3 179.48 163.3 0.68 0.1 0.68" })
	                ),
	                _react2.default.createElement(
	                    "g",
	                    { id: "Group-27", transform: "translate(510.000000, 154.000000)" },
	                    _react2.default.createElement(
	                        "mask",
	                        { id: "mask-18", fill: "white" },
	                        _react2.default.createElement("use", { xlinkHref: "#path-17" })
	                    ),
	                    _react2.default.createElement("g", { id: "Clip-26" }),
	                    _react2.default.createElement("polygon", { id: "Fill-25", fill: "#1AA97B", mask: "url(#mask-18)", points: "-0.1 21.04 42.98 21.04 42.98 -0.08 -0.1 -0.08" })
	                )
	            )
	        )
	    );
	};
	
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _emotion = __webpack_require__(6);
	
	var _header = __webpack_require__(287);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(286);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(807);
	
	var _livechat = __webpack_require__(324);
	
	var _livechat2 = _interopRequireDefault(_livechat);
	
	var _socialHero = __webpack_require__(968);
	
	var _socialHero2 = _interopRequireDefault(_socialHero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ContentClass = /*#__PURE__*/(0, _emotion.css)('margin-top:5.1rem;');
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data,
	      props = _objectWithoutProperties(_ref, ['children', 'data']);
	
	  var hasFrame = props.location.search.indexOf('frame=true') > -1;
	  if (!hasFrame) {
	    (0, _livechat2.default)(({"GATSBY_LIVE_CHAT_BUCKET":"demo","GATSBY_PLUGINS_SOURCE":"https://plugins.trywhistle.com","GATSBY_FACEBOOK_APPID":"822067874560098","GATSBY_FACEBOOK_PAGEID":"718319861593356","GATSBY_FACEBOOK_PIXELID":"833204747219774","ADWORDS_TRACKER_LEAD_FORM":"AW-844932343/Jf_qCLeXzeYBEPfJ8pID","NODE_ENV":"production","PUBLIC_DIR":"/home/circleci/project/public"}));
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: '' + (hasFrame ? 'hasFrame' : '') },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{ name: 'og:title', content: data.site.siteMetadata.title }, { name: 'description', content: data.site.siteMetadata.description }, { name: 'og:description', content: data.site.siteMetadata.description }, { name: 'og:image', content: _socialHero2.default }, { name: 'og:type', content: "website" }, { name: 'og:locale', content: "en_US" }]
	    }),
	    _react2.default.createElement(_header2.default, data.landing),
	    _react2.default.createElement(
	      'div',
	      { className: ContentClass },
	      children()
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var windowDocument = typeof document !== 'undefined' && document;
	
	var init = function init(env) {
	  if (windowDocument) {
	    var script = windowDocument.createElement("script");
	
	    script.innerHTML = "(function(){window.WhistleLiveChat={ company:'" + env.GATSBY_LIVE_CHAT_BUCKET + "', source: '" + env.GATSBY_PLUGINS_SOURCE + "' };var e=document.createElement(\"script\");e.async=!0,e.type=\"text/javascript\",e.src=window.WhistleLiveChat.source + \"/live-chat/initialize.js\";var t=document.getElementsByTagName(\"script\")[0];t.parentNode.insertBefore(e,t)}())";
	    script.async = true;
	    script.defer = true;
	
	    document.body.appendChild(script);
	  }
	};
	
	exports.default = init;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-c8c4fd7cb80c46351d4d.js